import styled from 'styled-components';
import { BodySmallMedium } from '../../../components/typography/styled';
import { statusColor } from '../../../utils/statusColor';
import SVG from 'react-inlinesvg';

type ActiveProp = {
  status?:string,
}
type ActivePropImg = {
  active?:boolean,
}
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 30px 30px 30px;
  box-sizing: border-box;
  position: relative;
`

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap:10px;
`

export const RowHeaderComponent = styled.div`
  display: flex;
  flex-direction: row;
  justify-content:space-between;
  width:100%;
`

export const RightSideComponent = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;

`

export const StatusDot = styled.div<ActiveProp>`
  width:12px;
  height:12px;
  background-color: ${({status}) => statusColor(status)};
  border-radius: 100%;
`
export const StatusText = styled(BodySmallMedium)<ActiveProp>`
  color:${({status}) => statusColor(status)};
  margin-left: 6px;
  margin-right: 5px;
  text-transform:capitalize;
`

export const StatusContainer = styled.div`
  display: flex;
  flex-direction:row;
  align-items:center;
`

export const ServiceBody = styled.div`
  padding-top:20px;
  display: flex;
  flex-direction:column;
  align-items:flex-start;
  width: 100%;
  /* box-sizing: border-box; */
  gap:10px;
`
export const TopInfoWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  /* flex-wrap: wrap; */
  gap: 10px;
`

export const BodyWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  /* justify-content: space-between; */
  flex-wrap: wrap;
  /* margin-top: 10px; */
  gap:10px;
`

export const ActionButtonsWrapper = styled.div`
  display: flex;
  gap: 15px;
  margin: 25px 0;
  justify-content: flex-start;
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 10px;
  }
`;

export const ConfigOptionsContainer = styled.div`
  background: ${({ theme }) => theme.palette[10]};
  border-radius: 8px;
  padding: 24px;
  margin-top: 25px;
  border: 1px solid ${({ theme }) => theme.palette[100]};
  width: 100%;

  h2 {
    margin-bottom: 20px;
    color: ${({ theme }) => theme.palette[900]};
  }

  p {
    margin: 0;
    color: ${({ theme }) => theme.palette[600]};
    font-style: italic;
  }
`;

export const StyledIconMore = styled(SVG)<ActivePropImg>`
  min-width: 20px;
  min-height: 20px;
  max-width: 20px;
  max-height: 20px;
  & path {
    fill: ${({ theme }) => theme.base.black};
  }
  filter: ${({active}) => active ? 'brightness(77%)' : ''};
  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
  &:active{
    filter: brightness(77%);
  }
`;

export const MenuContainer = styled.div<ActivePropImg>`
  position: absolute;
  right: 0px;
  top: 30px;
  z-index: 10;
  background-color: ${({theme}) => theme.palette[10]};
  width: 240px;
  padding: 4px 0px;
  border: ${({theme}) => `1px solid ${theme.grey[350]}`};
  border-radius: 4px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1), 0px 2px 10px rgba(0, 0, 0, 0.1);
  transform: ${({active}) => active ? 'scale(1)' : 'scale(0)'};
  opacity: ${({active}) => active ? '1' : '0'};
  transform-origin: top right;
  transition-property: transform, opacity;
  transition-duration: 0.2s;
  transition-timing-function: ease-out;
`;

export const TabsWrapper = styled.div`
  width: 100%;
  margin: 12px 0 4px;
`;

export const WarningBox = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px 14px;
  border: 1px solid ${({theme}) => theme.palette[100]};
  border-radius: 8px;
  background: ${({theme}) => theme.palette[10]};
  margin: 10px 0;
`;

export const WarningIcon = styled.img`
  width: 20px;
  height: 20px;
  margin-top: 2px;
`;

export const WarningText = styled.p`
  margin: 0;
  line-height: 1.4;
  color: ${({theme}) => theme.palette[900]};
`;

export const CyclesActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
  margin: 12px 0 8px;
`;
